/**
 * TestimonialsSection — eyebrow + heading + N testimonial cards (default 2).
 * Path: testimonials.{eyebrow, heading, items[i].{initials, name, quote}}
 *
 * Allows add/remove because the design easily accommodates 1..many cards.
 */

import {
  BilingualTextField, BilingualTextareaField,
  SectionPanel, ItemListEditor,
} from '../fields/BilingualFields'

const makeEmpty = () => ({ initials: '', name: '', quote: '' })

export default function TestimonialsSection({ getField, setField, draftEn, draftAr, setSubtree }) {
  const itemsEn = (draftEn?.testimonials?.items) || []
  const itemsAr = (draftAr?.testimonials?.items) || []

  const onChange = (newEn, newAr) => {
    setSubtree('en', 'testimonials.items', newEn)
    setSubtree('ar', 'testimonials.items', newAr)
  }

  return (
    <SectionPanel title="Testimonials" subtitle="Customer quotes — add or remove cards as you collect them">
      <BilingualTextField label="Eyebrow" path="testimonials.eyebrow" getField={getField} setField={setField} />
      <BilingualTextField label="Section heading" path="testimonials.heading" getField={getField} setField={setField} />

      <hr className="my-3 border-gray-200" />

      <ItemListEditor
        title="Testimonial cards"
        itemsEn={itemsEn}
        itemsAr={itemsAr}
        onChange={onChange}
        makeEmpty={() => ({ en: makeEmpty(), ar: makeEmpty() })}
        addLabel="Add testimonial"
        minItems={1}
      >
        {({ count, moveUp, moveDown, remove }) => (
          <div className="space-y-3">
            {Array.from({ length: count }).map((_, i) => (
              <div key={i} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-700">Testimonial {i + 1}</h4>
                  <div className="flex items-center gap-1 text-xs">
                    <button type="button" onClick={() => moveUp(i)} className="px-2 py-1 rounded border border-gray-300 hover:bg-white disabled:opacity-40" disabled={i === 0}>↑</button>
                    <button type="button" onClick={() => moveDown(i)} className="px-2 py-1 rounded border border-gray-300 hover:bg-white disabled:opacity-40" disabled={i === count - 1}>↓</button>
                    <button type="button" onClick={() => remove(i)} className="px-2 py-1 rounded border border-red-200 text-red-600 hover:bg-red-50 disabled:opacity-40" disabled={count <= 1}>Remove</button>
                  </div>
                </div>
                <BilingualTextField
                  label="Initials (circle badge, e.g. م.ر / LR)"
                  path={`testimonials.items.${i}.initials`}
                  getField={getField} setField={setField}
                />
                <BilingualTextField
                  label="Name / role"
                  path={`testimonials.items.${i}.name`}
                  getField={getField} setField={setField}
                />
                <BilingualTextareaField
                  label="Quote"
                  path={`testimonials.items.${i}.quote`}
                  getField={getField} setField={setField}
                  rows={2}
                />
              </div>
            ))}
          </div>
        )}
      </ItemListEditor>
    </SectionPanel>
  )
}
